import { FormlyFieldConfig } from "@ngx-formly/core";

export class AddressAdminForm {

    commonFields: FormlyFieldConfig[];
    fields: FormlyFieldConfig[];

    actionText = 'address.create.button';

    constructor(translateService, user, config?) {
        
        this.commonFields = [
            {
                key: 'name',
                type: 'input',
                hide: !user.roles.includes('superadmin'),
                props: {
                    required: true
                },
                expressions: {
                    'props.label': translateService.stream('fields.name')
                }
            },
            {
                key: 'personTo',
                type: 'input',
                hide: !user.roles.includes('superadmin'),
                props: {
                    required: true
                },
                expressions: {
                    'props.label': translateService.stream('fields.personTo')
                }
            },
            {
                key: 'line1',
                type: 'input',
                hide: !user.roles.includes('superadmin'),
                props: {
                    required: true
                },
                expressions: {
                    'props.label': translateService.stream('fields.address-line-1')
                }
            },
            {
                key: 'line2',
                type: 'input',
                hide: !user.roles.includes('superadmin'),
                expressions: {
                    'props.label': translateService.stream('fields.address-line-2')
                }
            },
            {
                key: 'postcode',
                type: 'input',
                hide: !user.roles.includes('superadmin'),
                props: {
                    required: true
                },
                expressions: {
                    'props.label': translateService.stream('fields.postcode')
                }
            },
            {
                key: 'region',
                type: 'input',
                hide: !user.roles.includes('superadmin'),
                props: {
                    required: true
                },
                expressions: {
                    'props.label': translateService.stream('fields.region')
                }
            },
            {
                key: 'country',
                type: 'input',
                hide: !user.roles.includes('superadmin'),
                defaultValue: 'España',
                props: {
                    required: true
                },
                expressions: {
                    'props.label': translateService.stream('fields.country')
                }
            },
        ]

        this.fields = this.commonFields;
    }    
}

export class AddressEditAdminForm {

    commonFields: FormlyFieldConfig[];
    fields: FormlyFieldConfig[];

    actionText = 'button.save';

    constructor(translateService, address, user, config?) {

        this.commonFields = [
            {
                key: 'name',
                type: 'input',
                hide: !user.roles.includes('superadmin'),
                defaultValue: address.name,
                props: {
                    required: true
                },
                expressions: {
                    'props.label': translateService.stream('fields.name')
                }
            },
            {
                key: 'personTo',
                type: 'input',
                hide: !user.roles.includes('superadmin'),
                defaultValue: address.personTo,
                props: {
                    required: true
                },
                expressions: {
                    'props.label': translateService.stream('fields.personTo')
                }
            },
            {
                key: 'line1',
                type: 'input',
                hide: !user.roles.includes('superadmin'),
                defaultValue: address.line1,
                props: {
                    required: true
                },
                expressions: {
                    'props.label': translateService.stream('fields.address-line-1')
                }
            },
            {
                key: 'line2',
                type: 'input',
                hide: !user.roles.includes('superadmin'),
                defaultValue: address.line2,
                expressions: {
                    'props.label': translateService.stream('fields.address-line-2')
                }
            },
            {
                key: 'postcode',
                type: 'input',
                hide: !user.roles.includes('superadmin'),
                defaultValue: address.postcode,
                props: {
                    required: true
                },
                expressions: {
                    'props.label': translateService.stream('fields.postcode')
                }
            },
            {
                key: 'region',
                type: 'input',
                hide: !user.roles.includes('superadmin'),
                defaultValue: address.region,
                props: {
                    required: true
                },
                expressions: {
                    'props.label': translateService.stream('fields.region')
                }
            },
            {
                key: 'country',
                type: 'input',
                hide: !user.roles.includes('superadmin'),
                defaultValue: address.country,
                props: {
                    required: true
                },
                expressions: {
                    'props.label': translateService.stream('fields.country')
                }
            },
        ]

        this.fields = this.commonFields;
    }    
}